export function calculateLoanTotal(principal, rate = 30) {
  const amount = Number(principal), percent = Number(rate);
  if (!Number.isFinite(amount) || amount <= 0 || !Number.isFinite(percent) || percent < 1 || percent > 100) return "";
  return (Math.round((amount * (1 + percent / 100) + Number.EPSILON) * 100) / 100).toFixed(2);
}
